// extracted by mini-css-extract-plugin
module.exports = {"header":"style_header__ZmJbu","title-container":"style_title-container__1ffmx","title":"style_title__25_iu","subtitle":"style_subtitle__l35gB","icon":"style_icon__1-hQ3"};